// mapboxConfig.js
// Mapbox configuration file for OTG (Overland Trail Guides)

/**
 * Mapbox public access token for OTG
 * This token can be safely used in client-side applications
 */
export const MAPBOX_ACCESS_TOKEN = 'pk.eyJ1Ijoib3ZlcmxhbmR0cmFpbGd1aWRlcyIsImEiOiJjbWM5ZDNveHUxejA2Mm1wdGZ3bGE5YmE4In0.5K63hpk1IaP_1Ji5ds5UPA';

/**
 * Default Mapbox configuration object
 */
export const MAPBOX_CONFIG = {
    accessToken: MAPBOX_ACCESS_TOKEN,

    // Default map styles
    styles: {
        streets: 'mapbox://styles/mapbox/streets-v11',
        outdoors: 'mapbox://styles/mapbox/outdoors-v11',
        light: 'mapbox://styles/mapbox/light-v10',
        dark: 'mapbox://styles/mapbox/dark-v10',
        satellite: 'mapbox://styles/mapbox/satellite-v9',
        satelliteStreets: 'mapbox://styles/mapbox/satellite-streets-v11'
    },

    // Default map settings
    defaultCenter: [-122.486052, 37.830348], // San Francisco Bay Area
    defaultZoom: 12,

    // API endpoints
    geocoding: {
        v6: 'https://api.mapbox.com/search/geocode/v6/forward',
        v5: 'https://api.mapbox.com/geocoding/v5/mapbox.places'
    }
};

// For CommonJS compatibility (if needed)
if (typeof module !== 'undefined' && module.exports) {
    module.exports = {
        MAPBOX_ACCESS_TOKEN,
        MAPBOX_CONFIG
    };
}

// Default export for convenience
export default MAPBOX_CONFIG;